<template>
  <CarouselContainer buttons-theme="shape" class="mx-auto w-full max-w-screen-tablet py-20">
    <CarouselSlide v-for="(slide, idx) in slides" :key="idx" :index="idx">
      <div class="px-14">
        <img class="mx-auto mb-10 h-16 tablet:h-20" src="~/assets/images/quotation-mark.svg" />

        <div class="mb-10 text-center text-xl italic tablet:text-2xl">
          {{ `„${slide.testimonial}“` }}
        </div>

        <div class="flex flex-col items-center text-sm">
          <img :src="slide.img" class="mb-4 h-20 w-20 rounded-full" />

          <div class="font-bold">
            {{ slide.name }}
          </div>

          <div>
            {{ slide.jobTitle }}
          </div>
        </div>
      </div>
    </CarouselSlide>
  </CarouselContainer>
</template>

<script setup lang="ts">
import { CarouselContainer, CarouselSlide } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

import FirstImg from '@/assets/images/testimonial1.jpg'
import SecondImg from '@/assets/images/testimonial2.jpg'
import ThirdImg from '@/assets/images/testimonial3.jpg'

import { useNuxtApp } from '#imports'

const { $i18n } = useNuxtApp()

const slides = computed(() => [
  {
    img: FirstImg,
    testimonial: $i18n.t('new_job_landing.testimonials.first.words'),
    name: $i18n.t('new_job_landing.testimonials.first.name'),
    jobTitle: $i18n.t('new_job_landing.testimonials.first.title'),
  },
  {
    img: SecondImg,
    testimonial: $i18n.t('new_job_landing.testimonials.second.words'),
    name: $i18n.t('new_job_landing.testimonials.second.name'),
    jobTitle: $i18n.t('new_job_landing.testimonials.second.title'),
  },
  {
    img: ThirdImg,
    testimonial: $i18n.t('new_job_landing.testimonials.third.words'),
    name: $i18n.t('new_job_landing.testimonials.third.name'),
    jobTitle: $i18n.t('new_job_landing.testimonials.third.title'),
  },
])
</script>
